import { REDUCER_NAME } from './const'
import { selectOwnState as selectParentState } from '../selector'
import { createTableSettingSelector } from '../../../form/state/table-state-helper'

export const selectOwnState = (state) => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectUnassignedPaymentList = (state) => {
    return selectOwnState(state).paymentList
}

export const selectCurrentPayment = (state) => {
    return selectOwnState(state).payment
}

export const selectTableSetting = createTableSettingSelector(selectOwnState)



// WEBPACK FOOTER //
// ./src/modules/payment/state/associate-payment/selector.js